import { all, put, takeLatest } from 'redux-saga/effects';

import { types as impactingPoliciesTypes } from '../ducks/impactingPolicies';

export function * watchImpactingPolicies() {
    yield takeLatest(impactingPoliciesTypes.IMPACTING_POLICIES_RESET, onImpactingPoliciesReset);
    yield takeLatest(impactingPoliciesTypes.IMPACTING_POLICIES_GET, onImpactingPoliciesGet);
    yield takeLatest(impactingPoliciesTypes.IMPACTING_POLICIES_SUCCESS, onImpactingPoliciesGetResponse);
}

export function * onImpactingPoliciesGet({ payload }) {
    payload.method = 'get';
    return yield payload;
}

export function * onImpactingPoliciesReset({ payload }) {
    payload.method = 'get';
    return yield payload;
}

export function * onImpactingPoliciesGetResponse({ response, payload }) {
    if (payload.action === 'get' && response && payload.dataset === 'impacting_policies') {
        return yield all([
            put({
                type: impactingPoliciesTypes.IMPACTING_POLICIES_SET,
                payload: response,
            }),
        ]);
    }
}
